import React from 'react'

export default class Loading extends React.Component {

  render () {
    const { visible } = this.props
    if (!visible) {
      return null
    }
    return (
      <div className='loader-background'>
        <div className="loader-container">
          <div className="loader">
            <div />
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Loading.js